"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentResourceRequirementResultMetadataSchema = exports.ComponentResourceRequirementInstanceMetadataSchema = exports.componentResourceRequirementResultTypeName = exports.ComponentResourceValidationResultKey = exports.ComponentResourceValidationRequirementTypeId = void 0;
const zod_1 = require("zod");
const IInsightError_1 = require("../../IInsightError");
exports.ComponentResourceValidationRequirementTypeId = 'ComponentResource';
exports.ComponentResourceValidationResultKey = 'ComponentResourceValidationResult';
exports.componentResourceRequirementResultTypeName = 'ComponentResourceResult';
exports.ComponentResourceRequirementInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentResourceValidationResultKey),
    moduleName: zod_1.z.string().optional(),
    componentResourceId: zod_1.z.string(),
});
exports.ComponentResourceRequirementResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.componentResourceRequirementResultTypeName),
    insights: zod_1.z.lazy(() => IInsightError_1.IInsightErrorSchema).array(),
});
//# sourceMappingURL=ComponentResourceRequirementInstanceMetadata.js.map